export const LABEL_COLOR_OPTION = [
  {
    name: 'Asda Green',
    value: '#22e39e',
  },
  {
    name: 'Lemon Meringue',
    value: '#F1E5BC',
  },
  {
    name: 'Azureish White',
    value: '#DDECF0',
  },
  {
    name: 'Gin',
    value: '#CDE3C1',
  },
  {
    name: 'Pale Blue',
    value: '#C5E9E3',
  },
  {
    name: 'Twitter Blue',
    value: '#4EA5D2',
  },
  {
    name: 'English Violet',
    value: '#524364',
  },
  {
    name: 'Yellow',
    value: '#ffd700',
  },
  {
    name: 'Violet',
    value: '#ee82ee',
  },
  {
    name: 'Pink',
    value: '#ffc022',
  },
  {
    name: 'Azureish White',
    value: '#DDEC23',
  },
  {
    name: 'Gin',
    value: '#CDE332',
  },
  {
    name: 'Pale Blue',
    value: '#C5E9E5',
  },
  {
    name: 'Twitter Blue',
    value: '#4EA5D1',
  },
  {
    name: 'English Violet',
    value: '#524362',
  },
  {
    name: 'Yellow',
    value: '#ffd711',
  },
  {
    name: 'Violet',
    value: '#ee82ee',
  },
  {
    name: 'Pink',
    value: '#ffc0cb',
  },
  {
    name: 'Bronze',
    value: '#CD7F32',
  },
  {
    name: 'Tan',
    value: '#D2B48C',
  },
  {
    name: 'Teal',
    value: '#008080',
  },
  {
    name: 'Coral',
    value: '#FF7F50',
  },
  {
    name: 'Lavender',
    value: '#E6E6FA',
  },
  {
    name: 'Mauve',
    value: '#E0b0FF',
  },
  {
    name: 'Peach',
    value: '#FFE5B4',
  },
  {
    name: 'Turquoise',
    value: '#30D5C8',
  },
  {
    name: 'Amber',
    value: '#FFBF00',
  },
  {
    name: 'Mint',
    value: '#3EB489',
  },
  {
    name: 'Dark Khaki',
    value: '#BDB76B',
  },
  {
    name: 'Medium Orchid',
    value: '#BA55D3',
  },
  {
    name: 'Indigo',
    value: '#4B0082',
  },
  {
    name: 'Medium Sea Green',
    value: '#3CB371',
  },
  {
    name: 'Yellow Green',
    value: '#9ACD32',
  },
  {
    name: 'Turquoise',
    value: '#40E0D0',
  },
  {
    name: 'Steel Blue',
    value: '#4682B4',
  },
  {
    name: 'Burly Wood',
    value: '#DEB887',
  },
  {
    name: 'Goldenrod',
    value: '#DAA520',
  },
  {
    name: 'Medium Slate Blue',
    value: '#7B68EE',
  },
  {
    name: 'Dim Gray',
    value: '#696969',
  },
  {
    name: 'Light Slate Gray',
    value: '#778899',
  },
  {
    name: 'Beige',
    value: '#F5F5DC',
  },
];
export const STATUS_COLOR_OPTION = [
  {
    name: 'Maroon',
    value: '#72002B',
  },
  {
    name: 'Plum Dyed',
    value: '#F68E4F',
  },
  {
    name: 'Sun Ray',
    value: '#E5B464',
  },
  {
    name: 'Shampoo',
    value: '#FFC5F3',
  },
  {
    name: 'Cadet Blue',
    value: '#649EA2',
  },
  {
    name: 'Irresistible',
    value: '#BA4769',
  },
  {
    name: 'Hot Pink',
    value: '#FF70BD',
  },
  {
    name: 'Emerald',
    value: '#50C878',
  },
  {
    name: 'Azure',
    value: '#1520A6',
  },
  {
    name: 'Electric',
    value: '#7EF9FF',
  },
];

// Combined & deduplicated by hex value (keeps first occurrence)
const _ALL_COLORS = [
  { name: 'Red', value: '#ff0000' },
  { name: 'Green', value: '#32cd32' },
  { name: 'Blue', value: '#0000ff' },
  { name: 'Black', value: '#000000' },
  ...LABEL_COLOR_OPTION,
  ...STATUS_COLOR_OPTION,
];
export const COLOR_OPTIONS = _ALL_COLORS.filter(
  (c, i, arr) => arr.findIndex(x => x.value.toLowerCase() === c.value.toLowerCase()) === i
);
